import { useNotification } from "../../../components/Notifications/NotificationContext";

export function useCopy() {
    const { showError, showSuccess } = useNotification();

    const copy = (e) => {
        try {
            e.preventDefault();
            navigator.clipboard.writeText(e.currentTarget.dataset.value);
            showSuccess("Texto copiado para a área de transferência!");
        } catch (err) {
            console.error("Failed to copy text: ", err);
            showError("Falha ao copiar o texto. Tente novamente.");
        }
    };

    return copy;
}